var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.2188H7.5V11.2188H8.5V10.2188Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.2188H7.5V13.2188H8.5V12.2188Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.55375V2.71875H13V1.71875H3V2.71875H4.5V6.55375C4.5 6.77012 4.57018 6.98065 4.7 7.15375L5.875 8.71875L4.7 10.2838C4.57018 10.4568 4.5 10.6674 4.5 10.8837V14.7188H3V15.7188H13V14.7188H11.5V10.8837C11.5 10.6674 11.4298 10.4568 11.3 10.2838L10.125 8.71875L11.3 7.15375C11.4298 6.98065 11.5 6.77012 11.5 6.55375ZM10.5 2.71875V6.21875H5.5V2.71875H10.5ZM10.5 10.8837V14.7188H5.5V10.8837L7.125 8.71875L6 7.21875H10L8.875 8.71875L10.5 10.8837Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWaiting);
export default __webpack_public_path__ + "static/media/ic-waiting.baf7c9ac39cf032d454d9e71bd4136d4.svg";
export { ForwardRef as ReactComponent };